import styled from 'styled-components';

export const TextWithDotStyles = styled.div`
  display: grid;
  grid-template-columns: 12px 1fr;
  gap: 12px;
  
  .dot {
    width: 12px;
    height: 12px;
    background: #FFC228;
    transform: translateY(calc(0.5em));
    border-radius: 100%;
  }
`;
